module.exports = __webpack_public_path__ + "static/media/etica.6346cd0f.svg";